<template>
    <div id="app">
        <Header/>
        <!-- <Search/>
        <Screening/> -->
        <router-view/>
        <Footer/>
        <Submit/>
    </div>
</template>

<script>
import Header from './views/Header';
import Footer from './views/Footer';
import Submit from './views/Submit';

export default {
  components: {
    Header,
    Footer,
    Submit
  },
  mounted() {
    this.$store.commit('getShow')
  }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #2c3e50;
}
html,body,ul,p,textarea,input,#app {
    margin: 0;
    padding: 0;
}
body {
    background: #fafafb;
}
li {
    list-style: none;
}
a {
    text-decoration: none;
    transition: all .3s ease;
}
img {
    display: block;
}
textarea {
    outline: none;
}
input {
    border: none;
}
tr,td {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    outline: none;
}

.search .el-select .el-input {
    width: 80px;
}

.search .el-input__inner,
.screening .el-radio-button__inner {
    border: none;
}
.screening .el-radio-button:first-child .el-radio-button__inner,
.screening .el-radio-button:last-child .el-radio-button__inner {
    border-left: none !important;
    border-radius: 0 !important;
}

#app .company-data .el-tabs__content {
    background: #fff;
    border: 1px solid #e4e8ea;
    padding: 20px;
}
#app .company-data .el-tabs__header {
    margin: 0;
}

#app .load1 {
    font-size: 30px;
}

.footer {
    margin-top: 40px;
}

.list {
	max-width: 1200px;
	margin: auto;
    min-height: 360px;
    display: flex;
    flex-wrap: wrap;
}
.list li {
    flex: 0 0 32%;
    display: flex;
    height: 160px;
    background: #fff;
    border: 1px solid #e4e8ea;
    box-sizing: border-box;
    cursor: pointer;
    margin: 0 2% 15px 0;
    transition: all .3s ease;
}
.list li:hover {
    border: 1px solid #409eff;
}
.list li:nth-child(3n+3) {
    margin-right: 0;
}
.list .list-left,
.list .list-right {
    display: flex;
    align-items: center;
}
.list .list-left {
    flex: 0 0 25%;
    border-right: 1px solid #e5e5e5;
}
.list .logo {
    /* height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center; */
    text-align: center;
    padding: 0 10px;
}
.list .logo img {
    width: 100%;
}
.list .text {
    text-align: left;
    padding-left: 10px;
}
.list .text p:first-child {
    font-size: 16px;
    font-weight: 600;
}
.list .text p:last-child {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    padding-right: 10px;
}
.page {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

@media(max-width: 868px) {
    .list-box {
        margin: auto;
    }
    .list {
        display: inherit;
        margin-top: 0;
    }
    .list li {
        height: auto;
        padding-bottom: 2px;
        margin: 0 0 10px 0;
    }
    .list .text p:last-child {
        height: 36px;
        -webkit-line-clamp: 2;
    }

    #app .screening .el-radio-button__inner {
        padding: 10px 15px;
    }
    #app .page .el-pager {
        display: none;
    }

    #app .el-dialog__wrapper {
        overflow-x: hidden;
    }
    #app .el-dialog {
        width: 100%;
    }
}
</style>
